var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoCircleBold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 .25a7.75 7.75 0 1 1 0 15.5A7.75 7.75 0 0 1 8 .25m0 1.5a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5m0 5.5a.75.75 0 0 1 .743.648L8.75 8v2.8a.75.75 0 0 1-1.493.102L7.25 10.8V8A.75.75 0 0 1 8 7.25m0-3.111a.75.75 0 0 1 .75.75v.467a.75.75 0 0 1-1.5 0v-.467a.75.75 0 0 1 .75-.75"
})));
export default SvgInfoCircleBold;